module.exports = __webpack_public_path__ + "static/img/introDownload.ee5b941d.png";